import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as detectAdblock from 'adblock-detect';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable, of } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
import { FeatureService } from '../permissions/feature/feature.service';
import { ApplicationState } from '../shared/store/application-state';
import { UserQuery } from '../shared/store/reducers/user.reducer';
import { AdblockDialogComponent } from './adblock-dialog.component';

@Injectable()
export class AdblockService {
	private static SESSION_STORAGE_KEY = 'adblock-checked';

	private set alreadyChecked(value: boolean) {
		sessionStorage.setItem(AdblockService.SESSION_STORAGE_KEY, `${ value }`);
	}

	private get alreadyChecked(): boolean {
		return sessionStorage.getItem(AdblockService.SESSION_STORAGE_KEY) === 'true';
	}

	private readonly http = inject(HttpClient);
	private readonly featureService = inject(FeatureService);
	private readonly store = inject<Store<ApplicationState>>(Store);
	private readonly dialogService = inject(DialogService);

	constructor() {
	}

	public detectAdblock(): void {
		this.store.select(UserQuery.getUser)
			.pipe(
				filter(Boolean),
				take(1),
				filter(() => !this.alreadyChecked),
				switchMap(() => this.hasAdblock()),
				take(1),
				filter(Boolean),
				tap(() => this.alreadyChecked = true),
				catchError(() => of(null)),
				switchMap(() => this.featureService.has('adblockDetect')),
				filter(Boolean),
				switchMap(() => this.http.post('rest/adblock/log', {})),
			)
			.subscribe(() => {
				this.dialogService.open(AdblockDialogComponent, {
					modal: true,
					showHeader: false,
				});
			});
	}

	private hasAdblock(): Observable<boolean> {
		return new Observable(subscriber => detectAdblock(val => subscriber.next(val)));
	}
}
